import { render, staticRenderFns } from "./WizardHeaderAf.vue?vue&type=template&id=abe2f99c"
import script from "./WizardHeaderAf.vue?vue&type=script&lang=js"
export * from "./WizardHeaderAf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports